var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('activity',{attrs:{"entries":_vm.entries,"title":"Activity","loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }